/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import TrueImpactBadge from 'shared/design-system/components/TrueImpactBadge';
import { COLORS } from 'shared/design-system/settings/variables/Colors';

const badgeStyles: React.CSSProperties = {
  top: 16,
  left: '50%',
  position: 'fixed',
  zIndex: 9999,
};

interface TrueImpactDebug {
  isDebug: boolean;
  letterKey?: string;
  debugText?: string;
  backgroundColor?: keyof typeof COLORS;
  onClick?: () => unknown;
  handleChange: React.Dispatch<React.SetStateAction<boolean>>;
}

const TrueImpactDebug: React.FC<TrueImpactDebug> = ({
  isDebug,
  letterKey = 'D',
  backgroundColor,
  debugText = 'Debug Mode',
  onClick,
  handleChange,
}) => {
  useEffect(() => {
    (window as any).isDebug = false;
  }, []);

  (window as any).openDebug = () => handleChange(true);
  (window as any).closeDebug = () => handleChange(false);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (
        (event.ctrlKey || event.metaKey) &&
        event.altKey &&
        event.code === `Key${letterKey}`
      ) {
        handleChange(o => {
          const newState = !o;
          (window as any).isDebug = newState;
          return newState;
        });
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isDebug]);

  if (!isDebug) return null;

  return (
    <TrueImpactBadge
      onClick={onClick}
      style={badgeStyles}
      backgroundColor={backgroundColor}
    >
      {debugText}: <strong>ON</strong>
    </TrueImpactBadge>
  );
};

export default TrueImpactDebug;
